var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 251,
    viewBox: "0 0 172 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1185_6648)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5934 42.3623C48.7953 42.3623 13.2898 77.8677 13.2898 121.666V135.339C13.2898 135.358 13.2898 135.378 13.2898 135.397C13.2898 152.111 26.8396 165.661 43.5541 165.661H141.633C158.347 165.661 171.897 152.111 171.897 135.397V121.666C171.897 77.8677 136.392 42.3623 92.5934 42.3623Z",
    fill: "#C4C4CD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7358 48.5272C70.7358 42.0272 76.0052 36.7578 82.5053 36.7578H102.681C109.182 36.7578 114.451 42.0272 114.451 48.5272H70.7358Z",
    fill: "#C4C4CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.3516,
    y: 9.85547,
    width: 4.76382,
    height: 26.9016,
    fill: "#C4C4CD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5935,
    cy: 6.77339,
    r: 5.88472,
    fill: "#C4C4CD"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M125.66 58.9722C125.66 60.3651 124.531 61.4942 123.138 61.4942C121.745 61.4942 120.616 60.3651 120.616 58.9722C120.616 57.5793 121.745 56.4502 123.138 56.4502C124.531 56.4502 125.66 57.5793 125.66 58.9722Z",
    fill: "#C4C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.16 74.768C132.389 69.7484 137.682 65.1556 142.402 67.6171C146.069 69.5298 146.658 74.5361 143.533 77.2467C140.409 79.9573 135.536 78.6687 134.16 74.768Z",
    fill: "#C4C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.3452 116.905C32.3452 97.0937 48.4057 81.0332 68.2173 81.0332H116.409C136.221 81.0332 152.281 97.0937 152.281 116.905C152.281 123.404 147.013 128.671 140.515 128.671H44.1113C37.6131 128.671 32.3452 123.404 32.3452 116.905Z",
    fill: "#1A1A24"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.897 112.182C31.897 137.967 52.7993 158.869 78.5837 158.869H105.21C130.995 158.869 151.897 137.967 151.897 112.182C151.897 103.725 145.041 96.8691 136.584 96.8691H47.2102C38.753 96.8691 31.897 103.725 31.897 112.182Z",
    fill: "#1A1A24"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.3539,
    cy: 106.953,
    r: 13.0304,
    fill: "#747480"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.7743,
    cy: 107.374,
    r: 10.6485,
    fill: "#1A1A24"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.465,
    cy: 106.953,
    r: 13.0304,
    fill: "#747480"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.885,
    cy: 107.374,
    r: 10.6485,
    fill: "#1A1A24"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8765 164.957L50.6411 172.181C56.797 174.052 60.5371 180.279 59.2966 186.592C57.9287 193.555 51.0609 197.995 44.1508 196.385L39.7711 195.365L24.6528 190.14C22.2003 189.293 19.9089 188.036 17.8756 186.424L11.7603 181.575C10.6391 180.686 9.66993 179.621 8.89075 178.421L5.96888 173.92C3.21672 169.681 4.78538 163.99 9.32071 161.759C11.2913 160.79 13.5621 160.628 15.6504 161.307L19.6351 162.603L26.8765 164.957Z",
    fill: "#C4C4CD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1185_6648)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8512 169.864C53.7082 169.864 44.6751 178.897 44.6751 190.04C44.6751 191.285 44.7877 192.503 45.0034 193.685C44.7888 194.573 44.675 195.5 44.675 196.453V199.848C44.675 228.015 67.5089 250.849 95.6759 250.849C123.843 250.849 146.677 228.015 146.677 199.848V196.453C146.677 195.5 146.563 194.573 146.348 193.685C146.564 192.503 146.677 191.285 146.677 190.04C146.677 178.897 137.644 169.864 126.501 169.864H64.8512Z",
    fill: "#C4C4CD"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.535 188.354L121.119 195.925L122.472 218.322C122.597 220.379 123.026 222.407 123.746 224.339L125.065 227.875C125.508 229.064 126.264 230.112 127.253 230.909L128.55 231.954C129.913 233.051 131.79 233.253 133.355 232.471C134.403 231.947 135.203 231.033 135.584 229.925L143.724 206.236C145.156 202.066 145.357 197.571 144.3 193.29L142.181 184.703C141.222 180.816 137.999 177.9 134.036 177.334C131.338 176.948 128.601 177.702 126.48 179.413L125.856 179.917C123.286 181.991 121.716 185.057 121.535 188.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.216 188.354L125.8 195.925L127.154 218.322C127.278 220.379 127.707 222.407 128.428 224.339L129.746 227.875C130.19 229.064 130.945 230.112 131.934 230.909L133.232 231.954C134.594 233.051 136.471 233.253 138.036 232.471C139.084 231.947 139.884 231.033 140.265 229.925L148.405 206.236C149.838 202.066 150.038 197.571 148.982 193.29L146.863 184.703C145.904 180.816 142.681 177.9 138.717 177.334C136.019 176.948 133.282 177.702 131.161 179.413L130.537 179.917C127.967 181.991 126.397 185.057 126.216 188.354Z",
    fill: "#C4C4CD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.7168,
    cy: 102.47,
    r: 4.34348,
    fill: "#747480"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1185_6648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.827,
    cy: 102.47,
    r: 4.34348,
    fill: "#747480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1185_6648",
    x: 13.2898,
    y: 42.3623,
    width: 158.607,
    height: 127.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1185_6648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1185_6648",
    x: 66.7358,
    y: 0.888672,
    width: 51.7151,
    height: 55.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1185_6648",
    x: 51.3235,
    y: 93.9229,
    width: 34.0608,
    height: 34.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1185_6648",
    x: 54.1257,
    y: 96.7256,
    width: 29.2971,
    height: 29.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1185_6648",
    x: 89.4341,
    y: 93.9229,
    width: 34.0608,
    height: 34.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1185_6648",
    x: 92.2363,
    y: 96.7256,
    width: 29.2971,
    height: 29.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1185_6648",
    x: 0.606689,
    y: 160.894,
    width: 62.9268,
    height: 43.8213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1185_6648",
    x: 44.675,
    y: 169.864,
    width: 102.002,
    height: 84.9854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1185_6648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1185_6648",
    x: 63.3733,
    y: 98.127,
    width: 16.687,
    height: 16.6865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1185_6648",
    x: 101.484,
    y: 98.127,
    width: 16.687,
    height: 16.6865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_6648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_6648",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotRobot);
export default __webpack_public_path__ + "static/media/chatbot-robot.08edb0ababc5f982d9e814cdd5731e5d.svg";
export { ForwardRef as ReactComponent };